export var InitKakao = function () {
    if (typeof window !== 'undefined') {
        if (!window.Kakao.isInitialized()) {
            window.Kakao.init(process.env.REACT_APP_KAKAO_API_KEY || '');
        }
        console.log('k: ', window.Kakao.isInitialized());
    }
};
//# sourceMappingURL=index.js.map